// Honeypot anti-bot: tidak terlihat manusia, bot pengisi form otomatis biasanya mengisinya.
export const QOHoneypot = ({ value, onChange }) => (
  <div style={{ display: "none", visibility: "hidden" }} aria-hidden="true">
    <label>
      Website
      <input type="text" name="website" tabIndex={-1} autoComplete="off"
        value={value} onChange={e => onChange(e.target.value)} data-testid="qo-hp-website" />
    </label>
  </div>
);

export const QO_LOAD_KEY = "qo_page_load_time";
export const qoElapsedSeconds = () => {
  const t = Number(sessionStorage.getItem(QO_LOAD_KEY) || 0);
  return t ? Math.round((Date.now() - t) / 100) / 10 : 0;
};
